import { ECHARTSCOLOR } from '@intelligence/utils/echartsConst';

/**
 * 获取游戏列表排序后，游戏对应的颜色映射
 *
 * @param {{ id: string }[]} data
 * @returns {*}
 */
export const getGamesColorMap = (data: { id: string }[]) => {
  if (!data?.length) return;

  return data?.reduce<{ [key: string]: string }>((prev, curr, index) => {
    prev[curr?.id] = ECHARTSCOLOR[index];
    return prev;
  }, {});
};
